import { render, staticRenderFns } from "./PartnersView.vue?vue&type=template&id=6e894640&scoped=true&"
import script from "./PartnersView.vue?vue&type=script&lang=js&"
export * from "./PartnersView.vue?vue&type=script&lang=js&"
import style0 from "./PartnersView.vue?vue&type=style&index=0&id=6e894640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e894640",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
